var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('book-my-bookings',{attrs:{"content":_vm.data,"config":_vm.config,"locale":_vm.locale,"isDesktop":false}})}
var staticRenderFns = []

export { render, staticRenderFns }